import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uuid from 'uuid/v4';
import {
  FormControl,
  Typography,
  Button,
  FormControlLabel,
  Switch,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import _ from 'lodash';
import { makeStyles } from '@material-ui/styles';

import { LookupDef } from '../../components/propTypeDefs';
import { getSingleLookupName } from '../../utils/incidentViewUtil';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
  },
  lineItem: {
    display: 'flex',
    // flexDirection: 'row',
    // alignItems: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
    // width: '100%',
  },
  formControlShort: {
    margin: theme.spacing(1),
    width: 150,
    // width: '100%',
  },
  formControlLong: {
    margin: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      minWidth: 400,
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  formControlFull: {
    margin: theme.spacing(1),
    width: '100%',
  },
  group: {
    margin: 0,
  },
  label: {
    marginLeft: theme.spacing(-1),
  },
  searchFields: {
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
}));

const LookupSingleSearchOption = props => {
  const classes = useStyles();
  const [state, setState] = React.useState({
    lookupId: '',
  });

  const handleChangeLookups = event => {
    const lookupId = event.target.value;
    const lookupValue = getSingleLookupName(event.target.value, props.lookups);
    setState({ ...state, lookupId, lookupValue });
  };

  const addSearchCriteria = () => {
    const { lookupId, lookupValue } = state;

    if (lookupId) {
      const lookup = {
        id: uuid(),
        lookupId,
        lookupValue,
      };
      props.onSearchCriteriaAdded(lookup);
    }
  };

  return (
    <React.Fragment>
      <div className={classes.root}>
        <Typography variant="h6">{props.title}</Typography>
        <div className={classes.searchFields}>
          <FormControl className={classes.formControl}>
            <InputLabel shrink>{props.title}</InputLabel>
            <Select
              value={state.lookupId || ''}
              onChange={handleChangeLookups}
              displayEmpty
              name={props.name}
              className={classes.selectEmpty}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {props.lookups.map(item => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className={classes.searchFields}>
          <FormControl className={classes.formControl}>
            <Button
              variant="contained"
              color="primary"
              className={classes.searchButton}
              onClick={addSearchCriteria}
            >
              Add Search Criteria
            </Button>
          </FormControl>
        </div>{' '}
      </div>
    </React.Fragment>
  );
};

LookupSingleSearchOption.propTypes = {
  onSearchCriteriaAdded: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  lookups: PropTypes.arrayOf(LookupDef).isRequired,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};
LookupSingleSearchOption.defaultProps = {
  onSearchCriteriaAdded: () => {},
};

const mapStateToProps = ({}) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LookupSingleSearchOption);
